import React from 'react';
import SelectionList from '@shared/components/SelectionList';

/**
 * @typedef {object} AtlSelectionListOwnProps
 * @property {Array<*>} [availableAtls]
 * @property {Object} [selectedAtl]
 */

/**
 * @typedef {AtlSelectionListOwnProps & React.ComponentPropsWithoutRef<typeof SelectionList>} AtlSelectionListProps
 */

/**
 * @param {AtlSelectionListProps} props
 */
export const AtlSelectionList = props => {
  const { availableAtls, selectedAtl, hasError, ...restProps } = props;

  const getOptions = () => {
    if (!availableAtls && !selectedAtl) {
      return [];
    }

    if (!availableAtls) {
      return [selectedAtl];
    }

    return availableAtls.map(atl => ({
      label: `${atl.UserLicense.Name} - ${atl.CurrentRole.Title}`,
      value: atl.ExternalUserId,
      currentRole: atl.CurrentRole.Value
    }));
  };

  return (
    <div className='option-selector'>
      <SelectionList
        {...restProps}
        key={selectedAtl}
        list={getOptions()}
        selectedValue={selectedAtl}
        showInputEndAdornment={false}
        allowAutocomplete={false}
        allowDeselectSingleSelect={true}
        hasError={hasError}
      />
    </div>
  );
};
